import { I18nAndL10n } from '@application/i18n/i18n_and_l10n';
import { withTranslation } from '@application/i18n/with_translation';
import { InputRadio } from '@cellula/react';
import { type RepresentativeRelationship } from '@feature/information-gathering/information-gathering.model';
import { InformationGatheringRepresentativeRelationship } from '@visiba/api-vcs-client-v2';
import { InformationGatheringForm } from './information-gathering-form';
import { useInformationGatheringJourney } from './use-information-gathering-journey';

interface RelationshipFormData {
	relationshipToPatient: RepresentativeRelationship | '';
}

export function RelationshipScreen() {
	const { draft, saveDraft, goNext, goBack } = useInformationGatheringJourney();

	function submit(data: RelationshipFormData) {
		saveDraft({
			...draft,
			representative: { ...draft.representative, relationshipToPatient: data.relationshipToPatient },
		});
		goNext();
	}

	return (
		<InformationGatheringForm
			title='View.CreateNewMessage.InformationGathering.RepresentativeDetails.Title'
			defaultValues={{ relationshipToPatient: draft.representative.relationshipToPatient }}
			onSubmit={submit}
			goBack={goBack}
		>
			<InputRadio.Root
				label={withTranslation('View.CreateNewMessage.InformationGathering.Relationship.Label')}
				variant='outlined'
				name='relationshipToPatient'
				required
				options={{ required: I18nAndL10n.translate('Form.ValidationError.OnlyOneOption') }}
			>
				<InputRadio.Item
					label={withTranslation('View.CreateNewMessage.InformationGathering.Relationship.ParentOrGuardian')}
					value={InformationGatheringRepresentativeRelationship.ParentOrGuardian}
				/>
				<InputRadio.Item
					label={withTranslation('View.CreateNewMessage.InformationGathering.Relationship.FamilyMember')}
					value={InformationGatheringRepresentativeRelationship.FamilyMember}
				/>
				<InputRadio.Item
					label={withTranslation('View.CreateNewMessage.InformationGathering.Relationship.Friend')}
					value={InformationGatheringRepresentativeRelationship.FriendOrNeighbour}
				/>
				<InputRadio.Item
					label={withTranslation('View.CreateNewMessage.InformationGathering.Relationship.Carer')}
					value={InformationGatheringRepresentativeRelationship.HealthcareProfessionalOrCarer}
				/>
				<InputRadio.Item
					label={withTranslation('View.CreateNewMessage.InformationGathering.Relationship.Other')}
					value={InformationGatheringRepresentativeRelationship.Other}
				/>
			</InputRadio.Root>
		</InformationGatheringForm>
	);
}
